// extracted by mini-css-extract-plugin
export var actions = "_16-0";
export var actionsContainer = "_16-7";
export var border = "_16-1";
export var childFullHeight = "_16-e";
export var collapse = "_16-2";
export var content = "_16-9";
export var contentChild = "_16-d";
export var fullscreen = "_16-b";
export var hasLeftRadius = "_16-q";
export var headerContainer = "_16-3";
export var headerRow = "_16-5";
export var hidePadding = "_16-a";
export var navCollapsedGap = "_16-r";
export var noScrollX = "_16-s";
export var noScrollY = "_16-t";
export var noTopPadding = "_16-o";
export var optOutTopPadding = "_16-c";
export var outletContent = "_16-k";
export var outletContentInner = "_16-l";
export var outletLeadingPanel = "_16-h";
export var outletLeadingPanelAttention = "_16-i";
export var outletResizeDivider = "_16-j";
export var outletSplit = "_16-f";
export var outletSplitResizing = "_16-g";
export var pageMain = "_16-p";
export var pageOuter = "_16-m";
export var pagePadding = "_16-8";
export var profile = "_16-u";
export var profileContainer = "_16-v";
export var profileImage = "_16-w";
export var profileMain = "_16-x";
export var profileSubtitle = "_16-z";
export var profileTitle = "_16-y";
export var showLeftPadding = "_16-n";
export var tabsPortalSlot = "_16-6";
export var tabsWrapper = "_16-4";
export var title = "_16-10";